import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
// Opcional: Importar iconos si es necesario, ej. import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

// Definición de colores
const lightPrimary = '#1E88E5'; // Azul Material 600
const lightSecondary = '#1565C0'; // Azul Material 800
const darkPrimary = '#1E88E5'; // Mantener el mismo azul o ajustar si se prefiere
const darkSecondary = '#1565C0';

export default new Vuetify({
    theme: {
        dark: false, // O true si quieres que el tema oscuro sea el predeterminado
        themes: {
            light: {
                primary: lightPrimary,
                secondary: lightSecondary,
                accent: '#82B1FF', // Azul claro
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
            },
            dark: {
                primary: darkPrimary,
                secondary: darkSecondary,
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
            },
        }
    },
    // Opcional: Configurar iconos si se importaron
    // icons: {
    //   iconfont: 'mdi', 
    // },
});
